// --- utils ---
const norm = (v) => String(v ?? "").trim(); // normalize ให้เป็น string ตัดช่องว่าง

// หา duplicate ภายในฟิลด์เดียว (เช่นเฉพาะ parcel_no)
const findDup = (rows = [], field) => {
  if (!["parcel_no", "parcel_no_response"].includes(field)) return [];
  const seen = new Map(); // value -> [rowIndex+1,...]
  rows.forEach((r, i) => {
    const v = norm(r?.[field]);
    if (!v) return;
    const arr = seen.get(v);
    arr ? arr.push(i + 1) : seen.set(v, [i + 1]); // ใช้ +1 ให้เป็นเลขแถวแบบมนุษย์
  });
  return [...seen.entries()]
    .filter(([, idxs]) => idxs.length > 1)
    .map(([value, rows]) => ({ field, value, rows }));
};

// หา duplicate แบบ "ชนกันข้ามฟิลด์" (ค่าเดียวกันไปอยู่ทั้ง parcel_no และ parcel_no_response)
const findCrossFieldDup = (rows = []) => {
  const where = new Map(); // value -> [{row, field}, ...]
  rows.forEach((r, i) => {
    ["parcel_no", "parcel_no_response"].forEach((field) => {
      const v = norm(r?.[field]);
      if (!v) return;
      (where.get(v) || where.set(v, []).get(v)).push({ row: i + 1, field });
    });
  });

  const res = [];
  for (const [value, list] of where.entries()) {
    const fields = [...new Set(list.map((x) => x.field))];
    if (fields.length > 1) {
      res.push({
        value,
        fields,
        rows: list.map((x) => x.row),
      });
    }
  }
  console.log("res", res);
  return res;
};

// รวมผลการตรวจทั้งหมด
export const findParcelDuplicates = (rows = []) => {
  const sameField = [
    ...findDup(rows, "parcel_no"),
    ...findDup(rows, "parcel_no_response"),
  ];
  const crossField = findCrossFieldDup(rows);
  return { sameField, crossField };
};
